export const ACCOUNT_PACKAGE = `/api/v1/subscriptions`;
export const PAYMENTS = `/api/v1/subscriptions/bills`;
export const PAYMENT_REDIRECT = `/api/v1/subscriptions/bills/payment`;
